import React from 'react';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import ReactProject from '../components/Home/ReactProject';
import RNproject from '../components/Home/RNproject';

function Works() {
    return (
        <div class="container">
            <h4 class="page-title my-3">Things I've Built</h4>
            <Row className="justify-content-md-center">
                <Col xs lg="10">
                    <Tabs
                        defaultActiveKey="react"
                        id="uncontrolled-tab-example"
                        className="mb-3"
                        style={{ borderBottom: 'none', textAlign: 'center' }}
                    >
                        <Tab eventKey="react" title="Web" style={{ marginRight: '5px' }}>
                            <ReactProject />
                        </Tab>
                        <Tab eventKey="native" title="Mobile">
                            <RNproject />
                        </Tab>
                    </Tabs>
                </Col>
            </Row>

        </div>
    )
}

export default Works;